import { serializable, alias, primitive } from 'serializr';

export class Tokens {
  @serializable(alias('password_reset', primitive()))
  passwordReset?: string | null;
}
